"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicroMillsRebalanced = void 0;
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var Resources_1 = require("../../../Resources");
var CardName_1 = require("../../../CardName");
var CardRenderer_1 = require("../../render/CardRenderer");
var MicroMillsRebalanced = (function (_super) {
    __extends(MicroMillsRebalanced, _super);
    function MicroMillsRebalanced() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.MICRO_MILLS_REBALANCED,
            cost: 2,
            metadata: {
                cardNumber: '164',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.heat(1); });
                }),
                description: 'Increase your heat production 1 step.',
            },
        }) || this;
    }
    MicroMillsRebalanced.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.HEAT, 1);
        return undefined;
    };
    return MicroMillsRebalanced;
}(Card_1.Card));
exports.MicroMillsRebalanced = MicroMillsRebalanced;
//# sourceMappingURL=MicroMillsRebalanced.js.map